const ON_LOAD = "ACT_ON_LOAD";
const UPDATE_CHAT = "ACT_UPDATE_CHAT";
const GET_CHAT_COOKIE = "ACT_GET_CHAT_COOKIE";
const SET_CHAT_COOKIE = "ACT_SET_CHAT_COOKIE";
const SHOW_CHAT_PROMPT = "ACT_SHOW_CHAT_PROMPT";
const SHOW_CHAT_PANEL = "ACT_SHOW_CHAT_PANEL";
const HIDE_CHAT_PANEL = "ACT_HIDE_CHAT_PANEL";
const REQUEST_CHAT_DETAILS = "ACT_REQUEST_CHAT_DETAILS";
const RECEIVE_CHAT_DETAILS = "ACT_RECEIVE_CHAT_DETAILS";
const RECEIVE_MYDPD_CHAT_DETAILS = "ACT_RECEIVE_MYDPD_CHAT_DETAILS";
const REQUEST_UPDATE_CHAT_LOG = "ACT_REQUEST_UPDATE_CHAT_LOG";
const RECEIVE_UPDATE_CHAT_LOG = "ACT_RECEIVE_UPDATE_CHAT_LOG";
const REQUEST_CHAT = "ACT_REQUEST_CHAT";
const RECEIVE_CHAT = "ACT_RECEIVE_CHAT";
const USE_SUGGESTION = "ACT_USE_SUGGESTION";
const RESET_CHAT_STATE = "ACT_RESET_CHAT_STATE";
const RESET_CONFIG_STATE = "ACT_RESET_CONFIG_STATE";
const DF_REQUEST_CREATE_SESSION = "ACT_REQUEST_CREATE_LIVE_AGENT_SESSION";
const DF_RECEIVE_CREATE_SESSION = "ACT_RECEIVE_CREATE_LIVE_AGENT_SESSION";
const DF_REQUEST_INIT_CHASITOR = "ACT_REQUEST_INIT_CHASITOR";
const DF_RECEIVE_INIT_CHASITOR = "ACT_RECEIVE_INIT_CHASITOR";
const DF_REQUEST_RESYNC_SESSION_STATE = "ACT_REQUEST_RESYNC_SESSION_STATE";
const DF_RECEIVE_RESYNC_SESSION_STATE = "ACT_RECEIVE_RESYNC_SESSION_STATE";
const DF_REQUEST_CHAT = "ACT_REQUEST_CHAT_MESSAGE";
const DF_RECEIVE_CHAT = "ACT_RECEIVE_CHAT_MESSAGE";
const DF_REQUEST_END_CHAT = "ACT_REQUEST_END_CHAT";
const DF_RECEIVE_END_CHAT = "ACT_RECEIVE_END_CHAT";
const DF_REQUEST_RESYNC_SESSION = "ACT_REQUEST_RESYNC_SESSION";
const DF_RECEIVE_RESYNC_SESSION = "ACT_RECEIVE_RESYNC_SESSION";
const DF_RECEIVE_CT_TYPING = "ACT_RECEIVE_CHASITOR_TYPING";
const DF_REQUEST_CT_NOT_TYPING = "ACT_REQUEST_CHASITOR_NOT_TYPING";
const DF_RECEIVE_CT_NOT_TYPING = "ACT_RECEIVE_CHASITOR_NOT_TYPING";
const DF_RECEIVE_MESSAGES = "ACT_RECEIVE_MESSAGES";
const SET_SEQUENCE = "SET_SEQUENCE";
const DF_REQUEST_CLIENT_END_CHAT = "ACT_DF_REQUEST_CLIENT_END_CHAT";
const DF_RECEIVE_CLIENT_END_CHAT = "ACT_DF_RECEIVE_CLIENT_END_CHAT";
const RETURN_TO_CHAT = "ACT_RETURN_TO_CHAT";
const END_CHAT = "ACT_END_CHAT";
const ENDING_CHAT = "ACT_ENDING_CHAT";
const REQUEST_SUBMIT_RATING = "ACT_REQUEST_SUBMIT_RATING";
const RECEIVE_SUBMIT_RATING = "ACT_RECEIVE_SUBMIT_RATING";
const SKIP_SUBMIT_RATING = "ACT_SKIP_SUBMIT_RATING";
const SEND_EVENT = "ACT_SEND_EVENT";
const RECEIVE_EVENT = "ACT_RECEIVE_EVENT";
const INIT_EXTERNAL_LISTENER = "ACT_INIT_EXTERNAL_LISTENER";
const REQUEST_CHAT_TRANSCRIPT = "ACT_REQUEST_CHAT_TRANSCRIPT";
const RECEIVE_CHAT_TRANSCRIPT = "ACT_RECEIVE_CHAT_TRANSCRIPT";
const CLOSE_CHAT = "ACT_CLOSE_CHAT";
const SAVE_POSITION = "ACT_SAVE_POSITION";
const REQUEST_AVERAGE_WAIT_TIME = "ACT_REQUEST_AVERAGE_WAIT_TIME";
const RECEIVE_AVERAGE_WAIT_TIME = "ACT_RECEIVE_AVERAGE_WAIT_TIME";
const REQUEST_QUEUE_MESSAGES = "ACT_REQUEST_QUEUE_MESSAGES";
const RECEIVE_QUEUE_MESSAGES = "ACT_RECEIVE_QUEUE_MESSAGES";
const RECEIVE_QUEUE_POSITION_MESSAGES = "ACT_RECEIVE_QUEUE_POSITION_MESSAGES";
const LEAVE_QUEUE = "ACT_LEAVE_QUEUE";
const CYCLE_QUEUE_MESSAGE = "ACT_CYCLE_QUEUE_MESSAGE";
const CYCLE_POSITION_MESSAGE = "ACT_CYCLE_POSITION_MESSAGE";
const DF_TIMED_QUEUE_JOIN_MESSAGE = "ACT_DF_TIMED_QUEUE_JOIN_MESSAGE";
const DF_RESET_QUEUE_JOIN_MESSAGE = "ACT_DF_RESET_QUEUE_JOIN_MESSAGE";
const LEAVING_QUEUE = "ACT_LEAVING_QUEUE";
const BACK_TO_QUEUE = "ACT_BACK_TO_QUEUE";
const REQUEST_CHAT_AN_ADVISOR = "ACT_REQUEST_CHAT_AN_ADVISOR";
const RECEIVE_CHAT_AN_ADVISOR = "ACT_RECEIVE_CHAT_AN_ADVISOR";
const GO_TO_ERROR_SCREEN = "ACT_GO_TO_ERROR_SCREEN";
const SET_CHAT_STATUS = "SET_CHAT_STATUS";
const SET_CHATBOT_SENDING = "ACT_SET_CHATBOT_SENDING";
const GET_FMP_CHAT_DETAILS = "/v1/chat/fmp/availability";
const GET_PARCEL = "/shipping/shipment/_/parcel";
const CHATBOT_CHAT = "/channels/fmp/messages";
const CHAT_AN_ADVISOR = "/user/device/consumerapp/?action=chatAdvisor";
const MYDPD_CHAT_AN_ADVISOR = "/mydpd/chat/?view=chatAnAdvisor";
const UPDATE_CHAT_LOG = "/v1/chat/log";
const GET_PREVIOUS_CHAT = "/v1/chat/history?parcelCode=[parcelCode]";
const GET_CHAT_TRANSCRIPT = "/v1/chat/transcript/";
const SUBMIT_CHAT_RATING = "/v1/chat/rating";
const MYDPD_SUBMIT_CHAT_RATING = "/mydpd/chat/?view=rating";
const DF_CREATE_LIVE_AGENT_SESSION = "/chat/rest/System/SessionId";
const DF_INIT_CHASITOR = "/chat/rest/Chasitor/ChasitorInit";
const DF_RESYNC_SESSION_STATE = "/chat/rest/Chasitor/ChasitorResyncState";
const DF_CHAT_MESSAGE = "/chat/rest/Chasitor/ChatMessage";
const DF_CHAT_END = "/chat/rest/Chasitor/ChatEnd";
const DF_RESYNC_SESSION = "/chat/rest/System/ResyncSession";
const DF_CHASITOR_NOT_TYPING = "/chat/rest/Chasitor/ChasitorNotTyping";
const DF_CHASITOR_TYPING = "/chat/rest/Chasitor/ChasitorTyping";
const DF_MESSAGES = "/chat/rest/System/Messages";
const GET_AVERAGE_WAIT_TIME = "/v1/chat/queue/averagewaittime";
const GET_QUEUE_MESSAGES = "/v1/chat/queue/messages";
const AGENT_NOT_AVAILABLE_MESSAGE = `We're really sorry we're unable to help you through this channel. 
If you would like to contact us our details can be found 
on https://www.dpd.co.uk/content/how-can-we-help/contact_fmp.jsp . 
Just be sure to have your tracking number at hand which is `;
const AGENT_NOT_AVAILABLE_MESSAGE_V2 = `All available delivery options 
allowed by the sender can be found on the tracking page. No need to call our contact centre as we've 
empowered you to do what they would normally do for you.`;
const MYDPD_WELCOME_MESSAGE = `Hi, tell us what you want to chat about, and we'll connect you to the right person in DPD`;
const MYDPD_WELCOME_SUGGESTIONS = [
  `Change delivery or provide delivery instructions`,
  `Investigation update`,
  `Proof of delivery request`,
  `Customer complaint`
];
const GET_CHAT_CONFIG = "/chat/config";
const RATE_CHAT = "/chat/rating";
const INITIATE_ADVISOR_CHAT = "/chat/advisor/initiate";
const CHAT_PROXY = "/chat/proxy";
const SET_CASE_ID = "ACT_SET_CASE_ID";
export {
  AGENT_NOT_AVAILABLE_MESSAGE,
  AGENT_NOT_AVAILABLE_MESSAGE_V2,
  BACK_TO_QUEUE,
  CHATBOT_CHAT,
  CHAT_AN_ADVISOR,
  CHAT_PROXY,
  CLOSE_CHAT,
  CYCLE_POSITION_MESSAGE,
  CYCLE_QUEUE_MESSAGE,
  DF_CHASITOR_NOT_TYPING,
  DF_CHASITOR_TYPING,
  DF_CHAT_END,
  DF_CHAT_MESSAGE,
  DF_CREATE_LIVE_AGENT_SESSION,
  DF_INIT_CHASITOR,
  DF_MESSAGES,
  DF_RECEIVE_CHAT,
  DF_RECEIVE_CLIENT_END_CHAT,
  DF_RECEIVE_CREATE_SESSION,
  DF_RECEIVE_CT_NOT_TYPING,
  DF_RECEIVE_CT_TYPING,
  DF_RECEIVE_END_CHAT,
  DF_RECEIVE_INIT_CHASITOR,
  DF_RECEIVE_MESSAGES,
  DF_RECEIVE_RESYNC_SESSION,
  DF_RECEIVE_RESYNC_SESSION_STATE,
  DF_REQUEST_CHAT,
  DF_REQUEST_CLIENT_END_CHAT,
  DF_REQUEST_CREATE_SESSION,
  DF_REQUEST_CT_NOT_TYPING,
  DF_REQUEST_END_CHAT,
  DF_REQUEST_INIT_CHASITOR,
  DF_REQUEST_RESYNC_SESSION,
  DF_REQUEST_RESYNC_SESSION_STATE,
  DF_RESET_QUEUE_JOIN_MESSAGE,
  DF_RESYNC_SESSION,
  DF_RESYNC_SESSION_STATE,
  DF_TIMED_QUEUE_JOIN_MESSAGE,
  ENDING_CHAT,
  END_CHAT,
  GET_AVERAGE_WAIT_TIME,
  GET_CHAT_CONFIG,
  GET_CHAT_COOKIE,
  GET_CHAT_TRANSCRIPT,
  GET_FMP_CHAT_DETAILS,
  GET_PARCEL,
  GET_PREVIOUS_CHAT,
  GET_QUEUE_MESSAGES,
  GO_TO_ERROR_SCREEN,
  HIDE_CHAT_PANEL,
  INITIATE_ADVISOR_CHAT,
  INIT_EXTERNAL_LISTENER,
  LEAVE_QUEUE,
  LEAVING_QUEUE,
  MYDPD_CHAT_AN_ADVISOR,
  MYDPD_SUBMIT_CHAT_RATING,
  MYDPD_WELCOME_MESSAGE,
  MYDPD_WELCOME_SUGGESTIONS,
  ON_LOAD,
  RATE_CHAT,
  RECEIVE_AVERAGE_WAIT_TIME,
  RECEIVE_CHAT,
  RECEIVE_CHAT_AN_ADVISOR,
  RECEIVE_CHAT_DETAILS,
  RECEIVE_CHAT_TRANSCRIPT,
  RECEIVE_EVENT,
  RECEIVE_MYDPD_CHAT_DETAILS,
  RECEIVE_QUEUE_MESSAGES,
  RECEIVE_QUEUE_POSITION_MESSAGES,
  RECEIVE_SUBMIT_RATING,
  RECEIVE_UPDATE_CHAT_LOG,
  REQUEST_AVERAGE_WAIT_TIME,
  REQUEST_CHAT,
  REQUEST_CHAT_AN_ADVISOR,
  REQUEST_CHAT_DETAILS,
  REQUEST_CHAT_TRANSCRIPT,
  REQUEST_QUEUE_MESSAGES,
  REQUEST_SUBMIT_RATING,
  REQUEST_UPDATE_CHAT_LOG,
  RESET_CHAT_STATE,
  RESET_CONFIG_STATE,
  RETURN_TO_CHAT,
  SAVE_POSITION,
  SEND_EVENT,
  SET_CASE_ID,
  SET_CHATBOT_SENDING,
  SET_CHAT_COOKIE,
  SET_CHAT_STATUS,
  SET_SEQUENCE,
  SHOW_CHAT_PANEL,
  SHOW_CHAT_PROMPT,
  SKIP_SUBMIT_RATING,
  SUBMIT_CHAT_RATING,
  UPDATE_CHAT,
  UPDATE_CHAT_LOG,
  USE_SUGGESTION
};
//# sourceMappingURL=Constants.js.map
